
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.335 8.855c.385-.336.744-.634 1.097-.912C28.53 4.72 34.19 5.722 37.409 9.372c3 3.401 3.31 7.324 1.387 11.753-1.399 3.22-3.561 5.968-6.95 9.224-1.887 1.813-4.942 4.25-9.177 7.325l-.731.53-.724-.54c-2.384-1.778-4.158-3.128-5.325-4.053-3.896-3.089-6.772-5.992-8.975-9.288-1.98-2.964-2.987-5.83-2.91-8.904.14-5.58 5.552-10.039 11.289-9.332 1.906.235 3.415 1.077 5.356 2.691.29.24.598.487.978.783l.492.382c.45-.405.973-.876 1.216-1.088zm6.81 19.724c3.175-3.05 5.155-5.565 6.4-8.431 1.568-3.614 1.338-6.528-.977-9.153-2.411-2.734-6.621-3.48-9.619-1.123-.318.25-.646.524-1.002.834-.413.359-1.743 1.567-1.96 1.757l-.765.673-.802-.63c-.24-.188-1.128-.873-1.303-1.01-.398-.31-.726-.572-1.037-.83-1.611-1.34-2.755-1.978-4.087-2.142-4.323-.533-8.432 2.852-8.535 6.957-.063 2.512.777 4.904 2.497 7.478 2.042 3.054 4.747 5.785 8.459 8.728 1.024.812 2.539 1.968 4.542 3.468 3.773-2.763 6.507-4.96 8.19-6.576z"}})])
          )
        }
      }
    